


































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetPapers } from "@/request/zsk";
@Component({})
export default class Literature extends Vue {
  private messages: any[] = [];
  private currentPage: any = 1;
  private totalCount: any = 1;
  @Prop()
  private searchText;
  /**
   * @description 跳转详情
   */
  private goToDetail(item) {
    this.$router.push({
      path: "/main/zsk/shezhen-detail",
      query: {
        id: item.paper_id,
      },
    });
  }
  /**
   * @description 获取文献列表
   */
  private getList(page?) {
    if (page) {
      this.currentPage = page;
    }
    const params = {
      search: this.searchText,
      current_page: this.currentPage,
      page_count: 10,
    };
    GetPapers(this, params).then((data) => {
      this.totalCount = data.total_count;
      this.messages = data.papers;
    });
  }
  /**
   * 改变页码
   */
  private handleCurrentChange(val) {
    this.currentPage = val;
    this.getList();
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.getList();
  }
}
